import { render, staticRenderFns } from "./VehicleRenewalInfo.vue?vue&type=template&id=55660ca7&scoped=true&"
import script from "./VehicleRenewalInfo.vue?vue&type=script&lang=js&"
export * from "./VehicleRenewalInfo.vue?vue&type=script&lang=js&"
import style0 from "./VehicleRenewalInfo.vue?vue&type=style&index=0&id=55660ca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55660ca7",
  null
  
)

export default component.exports